import React, { useCallback, useState } from 'react'

import DeleteTrip from '../Trips/DeleteTrip'
import EditTripName from '../Trips/EditTripName'

import LinePenIcon from 'components/Luxkit/Icons/line/LinePenIcon'
import LineTrashAltIcon from 'components/Luxkit/Icons/line/LineTrashAltIcon'
import ListItem from 'components/Luxkit/List/ListItem'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import { BasicTrip, FullTrip } from 'tripPlanner/types/common'
import { getTripPermissions } from 'tripPlanner/utils'

interface Props {
  trip: BasicTrip | FullTrip
}

export default function TripPanelActionMenu(props: Props) {
  const { trip } = props
  const [mode, setMode] = useState<'view' | 'edit' | 'delete'>('view')
  const onDeleteTripClicked = useCallback(() => setMode('delete'), [])
  const onEditNameClicked = useCallback(() => setMode('edit'), [])
  const { canEdit, canAdmin } = getTripPermissions(trip)

  return (
    <ModalBase dismissible={mode !== 'delete'}>
      {mode === 'view' && (
        <>
          <ModalHeader title={trip.name} />
          <ModalBody>
            <ModalContent>
              {canEdit && (
                <ListItem
                  startIcon={<LinePenIcon size="S" />}
                  title="Edit name"
                  onClick={onEditNameClicked}
                />
              )}
              {canAdmin && (
                <ListItem
                  startIcon={<LineTrashAltIcon size="S" />}
                  onClick={onDeleteTripClicked}
                  title="Delete trip"
                />
              )}
            </ModalContent>
          </ModalBody>
        </>
      )}
      {mode === 'edit' && <EditTripName trip={trip} />}
      {mode === 'delete' && <DeleteTrip trip={trip} />}
    </ModalBase>
  )
}
